export default __webpack_public_path__ + "static/media/z050ma0c.b43c44d6.mp3";